import { useEffect, useState, type ReactNode } from "react";
import { LockKeyhole, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { acquireAppAccess, type AccessState } from "@/lib/auth/exclusiveAppAccess";

/** Acquires before AuthProvider mounts: the newest tab takes over, older tabs stop rendering. */
export default function ExclusiveAppAccess({ children }: { children: ReactNode }) {
  const [state, setState] = useState<AccessState>("checking");
  const [attempt, setAttempt] = useState(0);
  useEffect(() => acquireAppAccess(navigator.locks, setState), [attempt]);
  if (state === "owned") return <>{children}</>;
  if (state === "checking") return <div role="status" className="min-h-dvh bg-background text-foreground flex items-center justify-center">Verificando acesso…</div>;
  const displaced = state === "displaced";
  return (
    <main className="min-h-dvh bg-background text-foreground flex items-center justify-center px-6">
      <section className="max-w-sm space-y-5 text-center" role="alert">
        <LockKeyhole className="mx-auto size-10 text-primary" aria-hidden="true" />
        <h1 className="text-xl font-display font-semibold">{displaced ? "O Zappy foi aberto em outra aba" : "Não foi possível proteger este acesso"}</h1>
        <p className="text-sm text-muted-foreground">{displaced
          ? "Para sua segurança, o Zappy fica ativo em uma aba por vez neste navegador. Toque abaixo para continuar por aqui; a outra aba será pausada."
          : "Atualize o navegador ou abra o Zappy em um navegador compatível. O acesso permanece bloqueado por segurança."}</p>
        <Button onClick={() => { setState("checking"); setAttempt((n) => n + 1); }}><RefreshCw />{displaced ? "Usar nesta aba" : "Tentar novamente"}</Button>
      </section>
    </main>
  );
}
